import { defineNuxtPlugin, useRoute } from '#imports';
import { useAuthStore } from '~/stores/auth';

export default defineNuxtPlugin({
  name: 'auth-bootstrap',
  async setup() {
    const authStore = useAuthStore();
    const route = useRoute();
    const publicRoutes = ['/login', '/forgot-password', '/api/auth/callback'];
    const isPublicRoute = publicRoutes.includes(route.path);

    if (!isPublicRoute && authStore.token) {
      await authStore.fetchUser();
    }
  },
});
